<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <span class="selected-name">{{ selected[nameKey] }}</span>
      <span v-if="selectLabel" class="selected-label">{{ selectLabel }}</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        class="session"
        @click="
          selected = option;
          open = false;
          selectOption(option);
        "
      >
        <span class="ico"
          ><i class="fa fa-fw" :class="{ 'fa-play': option.uuid === selected.uuid }" aria-hidden="true"></i
        ></span>
        <div>
          <span class="title">{{ option[nameKey] }}</span>
          <span v-if="option.subtitle" class="subtitle">{{ option.subtitle }}</span>
        </div>
        <span v-if="option.SESSION_START_TIME !== ''" class="start">
          <span class="date">{{ option.SESSION_START_TIME | formatDate("ddd Do MMM") }}</span>
          <span class="time">{{ option.SESSION_START_TIME | formatDate("HH:mm") }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Digital Event Custom dropdown selector
 */

export default {
  name: "CustomSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    default: {
      type: String,
      required: false,
      default: null
    },
    nameKey: {
      type: String,
      required: true,
      default: null
    },
    valueKey: {
      type: String,
      required: true,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selected: this.default ? this.default : this.options.length > 0 ? this.options[0] : null,
      open: false
    };
  },
  methods: {
    selectOption(data) {
      this.$emit("channel-selection", data);
    }
  }
};
</script>
